module.exports = __webpack_public_path__ + "media/images/flags/16/Costa-Rica-13dca9522f190b16fb865c89ee60f941.png";